import { CFormCheck } from '@coreui/react-pro'
import React from 'react'

const DynamicSectionFilter = ({
  section,
  addSelectedSection,
  removeSelectedSection,
  isChecked,
}) => {
  const isSelected = isChecked || !section.optional

  const evaluateFilterClick = (isChecked) => {
    if (isChecked) {
      addSelectedSection(section)
    } else {
      removeSelectedSection(section)
    }
  }

  return (
    <div className="section-filter">
      <div className="filter-check-box">
        <CFormCheck
          id={section?.title}
          label={`${section?.title} ${!section.optional ? '*' : ''}`}
          disabled={!section.optional}
          onChange={(e) => evaluateFilterClick(e.currentTarget.checked)}
          checked={Boolean(isSelected)}
        />
      </div>
    </div>
  )
}

export default DynamicSectionFilter
